import { Component } from '@angular/core';
import { GlobalService } from 'app/core/services/global/global.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  currentYear: number = new Date().getFullYear();

  constructor(public _global: GlobalService){}
}
